import { attachmentContract } from "@/api/dilivery/sales/contract";
import { downloadRecord } from "@/api/dilivery/record";
import { getMaterialType } from "@/api/dilivery/material/lexicon";
import { getDataInLocalStorage } from "@/utils/localStorage";

const baseURL = process.env.VUE_APP_BASE_API;

/**
 * 详情展示公共方法混入 - 供合同详情、发票记录详情、审核详情共用
 * 提供：金额格式化、区块折叠、物料信息、附件下载/预览等通用方法
 */
export default {
  data() {
    return {
      LexiconOptions: [],
    };
  },
  methods: {
    formatAmount(value) {
      if (value === null || value === undefined || value === '') return '-';
      const num = Number(value);
      if (Number.isNaN(num)) return value;
      return '¥' + num.toLocaleString('zh-CN');
    },
    toggleSection(section) {
      this.sectionOpen[section] = !this.sectionOpen[section];
    },
    findName(id) {
      const material = this.LexiconOptions.find(item => item.id === id);
      return material ? material.materialName : '';
    },
    async getLexiconOptions() {
      try {
        const res = await getMaterialType({ type: 'PROTECT_REAGENT' });
        if (res.code === 200) {
          this.LexiconOptions = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    materialSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const data = this.flatMaterialTracking;
        if (rowIndex === 0 || data[rowIndex].trackingFlag !== data[rowIndex - 1].trackingFlag) {
          let span = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].trackingFlag === data[rowIndex].trackingFlag) span++;
            else break;
          }
          return { rowspan: span, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    async downloadContractAttachment(id, type) {
      try {
        let annex;
        switch (type) {
          case 'contract': annex = 'CONTRACT_ANNEX'; break;
          case 'senior': annex = 'SENIOR_ANALYSIS_ANNEX'; break;
          case 'customized': annex = 'CUSTOMIZED_ANALYSIS_ANNEX'; break;
          case 'price': annex = 'PRICE_APPLE_ANNEX'; break;
          default: break;
        }
        let url;
        if (type === 'record') {
          url = `${baseURL}/invoice-record/attachment/${id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
        } else {
          url = `${baseURL}/sequencing-contract/attachment/${id}/${annex}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
        }
        const elink = document.createElement('a');
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async previewContractAttachment(id, type) {
      try {
        if (type === 'record') {
          this.fileInfo = await downloadRecord(id);
        } else {
          let annex;
          switch (type) {
            case 'contract': annex = 'CONTRACT_ANNEX'; break;
            case 'senior': annex = 'SENIOR_ANALYSIS_ANNEX'; break;
            case 'customized': annex = 'CUSTOMIZED_ANALYSIS_ANNEX'; break;
            case 'price': annex = 'PRICE_APPLE_ANNEX'; break;
            default: break;
          }
          this.fileInfo = await attachmentContract(id, annex);
        }
        this.showFile = true;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.showFile = false;
      this.fileInfo = '';
    },
    /**
     * 构建物料扁平化列表（供 el-table 展示）
     * @param {Array} mail - protectiveFluidMail 数组
     * @param {Array} materials - materials 数组
     * @returns {Array}
     */
    _buildFlatMaterialTracking(mail, materials) {
      const rows = [];
      if (mail && mail.length > 0) {
        mail.forEach(group => {
          const statusText = group.trackingFlag === 1 ? '已邮寄' : group.trackingFlag === 0 ? '待邮寄' : '已取消';
          const statusType = group.trackingFlag === 1 ? 'success' : group.trackingFlag === 0 ? 'warning' : 'danger';
          group.details.forEach(detail => {
            rows.push({ ...detail, trackingFlag: group.trackingFlag, statusText, statusType });
          });
        });
      } else if (materials && materials.length > 0) {
        materials.forEach(m => {
          rows.push({
            materialName: this.findName(m.materialId) || '-',
            specs: m.specs || '',
            number: m.materialNumber || '',
            trackingFlag: 'pending',
            statusText: '待审核',
            statusType: 'info'
          });
        });
      }
      return rows;
    },
  }
};
